import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex-node-col card-gap text-left" }
const _hoisted_2 = { class: "flex-container-row flex-wrap gap5" }
const _hoisted_3 = { class: "flex-node-col" }
const _hoisted_4 = { class: "flex-node-col" }
const _hoisted_5 = ["checked", "onChange"]
const _hoisted_6 = {
  class: "text-center",
  style: {"margin":"10px 0 5px 0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_title = _resolveComponent("card-title")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_card = _resolveComponent("card")!
  const _component_grid = _resolveComponent("grid")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_loader_guard = _resolveComponent("loader-guard")!

  return (_openBlock(), _createBlock(_component_loader_guard, {
    hasLoaded: _ctx.hasLoaded,
    class: "flex-node-col"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_card, { class: "flex-item" }, {
          default: _withCtx(() => [
            _createVNode(_component_card_header, { class: "k-hstack section" }, {
              default: _withCtx(() => [
                _createVNode(_component_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('LoggedInAs')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_card_body, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_header, { class: "label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.localize('Username')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card_body, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.userName), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_header, { class: "label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.localize('Company')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card_body, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.partnerInfo), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_header, { class: "label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.localize('Currency')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card_body, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.currency), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.showUserList)
          ? (_openBlock(), _createBlock(_component_card, {
              key: 0,
              id: "userCard",
              class: "flex-node-col"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_card_header, { class: "k-hstack section" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.localize('Users')) + " - " + _toDisplayString(_ctx.partnerInfo), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_card_body, { class: "flex-node-col" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_grid, {
                          class: "NoRowHover",
                          "data-items": _ctx.userData,
                          columns: _ctx.columns,
                          style: {"height":"100%","border":"1px solid grey","margin-bottom":"10px"},
                          scrollable: "scrollable"
                        }, {
                          general: _withCtx(({props}) => [
                            _createElementVNode("td", {
                              class: _normalizeClass([props.className, props.dataItem['isLockedOut'] ? 'red-row' : ''])
                            }, _toDisplayString(props.dataItem[props.field]), 3)
                          ]),
                          bool: _withCtx(({props}) => [
                            _createElementVNode("td", {
                              class: _normalizeClass([props.className, props.dataItem['isLockedOut'] ? 'red-row' : ''])
                            }, _toDisplayString(props.dataItem[props.field] ? 'X' : '-'), 3)
                          ]),
                          isPriceAccessAllowed: _withCtx(({props}) => [
                            _createElementVNode("td", {
                              class: _normalizeClass([props.className, props.dataItem['isLockedOut'] ? 'red-row' : ''])
                            }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: props.dataItem[props.field],
                                onChange: ($event: any) => (_ctx.onCheckBoxChange(props.dataItem, $event.target.checked))
                              }, null, 40, _hoisted_5)
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["data-items", "columns"])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_k_button, {
                          ref: "btnSave",
                          onClick: _ctx.saveChanges,
                          icon: "save",
                          class: "button-save min-w-200"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('Save')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ], 512), [
                        [_vShow, _ctx.anyChanges]
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["hasLoaded"]))
}